export const loadFindbarScript = () => {
	if (process.env.REACT_APP_FINDBAR_ENABLED === 'true') {
		const lang = localStorage.getItem('I18N_LANGUAGE') === 'en' ? 'en' : 'el';
		const script = document.createElement('script');
		script.type = 'text/javascript';
		script.src = lang === 'el' ? process.env.REACT_APP_FINDBAR_URL_EL : process.env.REACT_APP_FINDBAR_URL_EN;
		script.async = true;
		document.body.appendChild(script);
	}
};

const loadCustomScripts = () => {
	loadFindbarScript();
};

export default loadCustomScripts;
